import { z } from "zod";
import { AuthorizationResultSchema } from "./authz";
export const ObjectAction = z.object({
    kind: z.string(),
    object: z.object({}).passthrough(),
    action: z.string()
});
const AuditLogSchema = z.object({
    auditLogId: z.string(),
    requestId: z.string(),
    requestUrl: z.string(),
    authorizationCheckType: z.enum([
        "NONE",
        "ADMIN",
        "OBJECT_ACTION"
    ]),
    userId: z.number().optional(),
    organizationId: z.number().optional(),
    organizationIds: z.array(z.number()).optional(),
    authorized: z.boolean().optional(),
    // Only present if the authorization check works
    authorizedOrganizationId: z.number().optional(),
    objectActions: z.array(ObjectAction),
    authorizationResults: z.array(AuthorizationResultSchema),
    timestamp: z.date(),
    releaseSha: z.string(),
    input: z.string().optional().default("")
});
// The schema we need for publishing to clickhouse
export const AuditLogSchemaClickhouse = AuditLogSchema.omit({
    timestamp: true
}).extend({
    timestamp: z.string()
});
export default AuditLogSchema;
